import type { FaireProductEntity } from "../../entity_types/product";

export const p_hy7a2gadpb: FaireProductEntity = {
  token: "p_hy7a2gadpb",
  type: "product",
  name: "Karl the Fog (Mini Size, 3.8 oz)",
  brandToken: "b_2tfmqenqs6",
  brandName: "North Bay Candleworks",
  imageUrl:
    "https://cdn.faire.com/fastly/dcd48937b3b36208c90d980c931f87c56a0f9d5d917dbceed653a0e57efda083.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/065cddc8f3a69451334d2b24ffee82fb79e1b4bfa10186bceba2e6400c8688e1.png",
    "https://cdn.faire.com/fastly/1ef4e755efb6be36bd082a0afbce69659ab8dfcbf529cfecca5ecdf294d6ac3b.jpeg",
    "https://cdn.faire.com/fastly/2c6c4ff7d80defcc97b74f3ce036591079451efbc86d400c5ba55afa23a44ce8.jpeg",
    "https://cdn.faire.com/fastly/5068031edda71f37ac278ddf1aa7cff923effef2cf0e21ac846655625c4ce67a.jpeg",
  ],
  priceDollars: 7,
  description:
    "Our Marin Line takes you on the tour of some of our favorite places in the Bay Area, focusing on Marin County. First launched in partnership with the Sausalito Center of Commerce, this line has become so popular that we are sharing it with the world now! Soy + Coconut Wax Blend Candle. Net Contents 3.8 oz / 108 g. Hand-poured in Marin County, CA.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:01.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
